import React, { useEffect } from 'react'

import Script from 'next/script'

import SetCookie from 'Utilities/CookieUtilties/SetCookie'

import useGlobalPrivacyControl from 'Hooks/useGlobalPrivacyControl'

const checkForBait = () => {
  if (typeof document == `undefined`) {
    return
  }
  var elem = document.getElementById(`banner_ad_3847646`)
  console.log(`smi_ab`, !!elem ? '0' : `1`)
  SetCookie(`smi_ab`, !!elem ? '0' : `1`)
}

export default function Tracking() {
  const { isGpcEnabled } = useGlobalPrivacyControl()

  useEffect(() => {
    setTimeout(checkForBait, 1000)
  }, [])

  if (isGpcEnabled) {
    return null
  }

  return (
    <>
      <Script
        enableOnlyOnNextFrontEnd={true}
        id="googleads-init"
        data-testid="googleads-init"
        strategy="afterInteractive"
        src="https://www.googleadservices.com/pagead/conversion_async.js"
      />

      <Script
        enableOnlyOnNextFrontEnd={true}
        id="facebookTracking-load"
        data-testid="facebookTracking-load"
        strategy="afterInteractive"
        src="https://connect.facebook.net/en_US/fbevents.js"
      />

      <Script
        id="smi_ab"
        data-testid="smi_ab"
        strategy="afterInteractive"
        src={`/microad.js`}
        onLoad={checkForBait}
        onError={checkForBait}
      />
    </>
  )
}
